// Portals station values
export const ONLINE = 'online';
export const OFFLINE = 'offline';
export const CONNECTED = 'connected';
export const DISCONNECTED = 'disconnected';
export const CHARGING = 'charging';
export const NOT_CHARGING = 'not charging';

// Portals roles
export const ROLES = {
  KITU_ADMIN: 1,
  SUPER_SITE_ADMIN: 2,
  SITE_ADMIN: 3,
  INSTALLER: 4,
  DRIVER: 5,
};

export const ROLE_DISPLAY_NAMES = {
  1: 'Kitu Admin',
  2: 'Super Site Admin',
  3: 'Site Admin',
  4: 'Installer',
  5: 'Driver',
};

// To help determine tooltip/subtitle text based on station status/connectivity
export const stationTooltips = {
  [OFFLINE]: {
    [CONNECTED]: 'station.offline',
    [DISCONNECTED]: 'station.offline',
  },
  [ONLINE]: {
    [CONNECTED]: 'station.occupied',
    [DISCONNECTED]: 'station.available',
  },
};

const ACCESS = 'Access';
const ACCESS_PAYMENT = 'Access Payment';
const PUBLIC_PAYMENT = 'Public Payment';
const OPEN = 'Open';
// technically applies to sites also
export const STATION_TYPES = {
  ACCESS,
  ACCESS_PAYMENT,
  PUBLIC_PAYMENT,
  OPEN,
};
export const PAYMENT_STATION_TYPES = [ACCESS_PAYMENT, PUBLIC_PAYMENT];

// Payment codes
export const UNPAID = 'U';

// Stripe error codes
export const STRIPE_ACCOUNT_VALIDATION_FAILURE = 'stripe-account';

// Session Scheme types
export const SCHEME_TYPES = {
  CTL: 'connectionTimeLimit',
};

// Temporary: Site’s utility settings will need to be reviewed prior to PGE merge into Charge Ready.
// that utility setting should be used for DR Events.
export const DR_EVENT_UTILITY = 'SCE';

// Portals errors that must match exactly
export const MESSAGES_FROM_SERVER = {
  REQUESTING_REFRESH_TOKEN: 'Requesting refresh token',
};
